import React, { useState, useRef, useCallback, useEffect } from "react";
import { ReactComponent as SearchIcon } from "../../asset/iconamoon_search-light.svg";
import useFetchcreatorPackages from "../libs/fetchCreatorPackages";
import { FaXmark } from "react-icons/fa6";
import Spinner from "../../utils/spinner";
import "./Branch_packages.css";

export default function Superadminallbranchpackages() {
  const [searchTerm, setSearchTerm] = useState("");
  const [packageOverlay, setPackageOverlay] = useState(false);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [selectedCreatorDetails, setSelectedCreatorDetails] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [packageSearchTerm, setPackageSearchTerm] = useState("");
  const itemsPerPage = 10; // Fixed items per page

  const {
    data,
    isLoading,
    isError,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
  } = useFetchcreatorPackages();

  const creatorArray =
    data?.pages?.flatMap((page) => page.groupedPackages) || [];

  const filteredCreator = creatorArray.filter((creator) => {
    if (!searchTerm) return true;
    const searchLower = searchTerm.toLowerCase();
    const firstName = creator?.creatorDetails?.first_name?.toLowerCase() || "";
    const lastName = creator?.creatorDetails?.last_name?.toLowerCase() || "";
    const email = creator?.creatorDetails?.email?.toLowerCase() || "";
    const fullName = `${firstName} ${lastName}`.trim();

    return (
      firstName.includes(searchLower) ||
      lastName.includes(searchLower) ||
      email.includes(searchLower) ||
      fullName.includes(searchLower)
    );
  });

  const observerRef = useRef();
  const lastCreatorElementRef = useCallback(
    (node) => {
      if (isFetchingNextPage) return;
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNextPage) {
          fetchNextPage();
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [isFetchingNextPage, fetchNextPage, hasNextPage]
  );

  const handleViewCreatorPackages = (creatorId) => {
    const selectedCreator = creatorArray.find(
      (creator) => creator.creatorId === creatorId
    );
    setSelectedPackages(selectedCreator?.packages || []);
    setSelectedCreatorDetails(selectedCreator?.creatorDetails || null);
    setCurrentPage(1); // Reset to first page when opening modal
    setPackageSearchTerm(""); // Reset package search when opening modal
    setPackageOverlay(true);
  };

  // Filter packages based on search term
  const filteredPackages = selectedPackages.filter((pkg) => {
    if (!packageSearchTerm) return true;
    const searchLower = packageSearchTerm.toLowerCase();
    const trackingNumber = pkg.tracking_number?.toLowerCase() || "";
    const senderName = pkg.sender?.name?.toLowerCase() || "";
    const receiverName = pkg.receiver?.name?.toLowerCase() || "";

    return (
      trackingNumber.includes(searchLower) ||
      senderName.includes(searchLower) ||
      receiverName.includes(searchLower)
    );
  });

  const totalPages = Math.ceil(filteredPackages.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const paginatedPackages = filteredPackages.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Reset to page 1 when search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [packageSearchTerm]);
  return (
    <>
      {packageOverlay && (
        <div className="creator-package-overlay">
          <div className="package-info">
            <span className="modal-header">
              <h3>
                Packages Created by: {selectedCreatorDetails?.first_name}{" "}
                {selectedCreatorDetails?.last_name}
              </h3>
              <button
                onClick={() => setPackageOverlay(false)}
                className="close-btn"
                aria-label="Close modal"
              >
                <FaXmark />
              </button>
            </span>
            <div className="modal-search-container">
              <div className="modal-search-wrapper">
                <SearchIcon className="modal-search-icon" />
                <input
                  type="search"
                  placeholder="Search packages by tracking number, sender, or receiver..."
                  value={packageSearchTerm}
                  onChange={(e) => setPackageSearchTerm(e.target.value)}
                  className="modal-search-input"
                />
              </div>
            </div>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Tracking Number</th>
                    <th>Sender Name</th>
                    <th>Receiver Name</th>
                    <th>Item/Weight</th>
                    <th>Quantity</th>
                    <th>Date Created</th>
                    <th>Est. Deliv Date</th>
                    <th>Shipping Cost</th>
                    <th>Emergency Deliv</th>
                    <th>Pick Up</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedPackages.length > 0 ? (
                    paginatedPackages.map((pkg) => (
                      <tr key={pkg.tracking_number}>
                        <td>{pkg.tracking_number}</td>
                        <td>{pkg.sender?.name}</td>
                        <td>{pkg.receiver?.name}</td>
                        <td>
                          {pkg?.items?.map((item) => (
                            <div key={item?._id}>
                              {item?.name} / {item?.weight}kg
                            </div>
                          )) || "N/A"}
                        </td>
                        <td>
                          {pkg?.items?.map((item) => (
                            <div key={item?._id}>{item?.quantity}</div>
                          )) || 0}
                        </td>
                        <td>
                          {new Date(pkg.dateCreated).toLocaleDateString()}
                        </td>
                        <td>
                          {new Date(
                            pkg.estimated_delivery_date
                          ).toLocaleDateString()}
                        </td>

                        <td>
                          {pkg?.shipping_cost?.toLocaleString("en-US", {
                            style: "currency",
                            currency: "NGN",
                          })}
                        </td>
                        <td>{pkg.isEmergency ? "Yes" : "No"}</td>
                        <td>{pkg.isPickupRequired ? "Yes" : "No"}</td>
                      </tr>
                    ))
                  ) : selectedPackages.length === 0 ? (
                    <tr>
                      <td
                        colSpan="11"
                        style={{
                          textAlign: "center",
                          padding: "40px",
                          color: "#666",
                        }}
                      >
                        No packages available for this creator
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td
                        colSpan="11"
                        style={{
                          textAlign: "center",
                          padding: "40px",
                          color: "#666",
                        }}
                      >
                        No packages found matching "{packageSearchTerm}"
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="modal-pagination">
              <div className="pagination-info">
                <span className="showing-info">
                  Showing{" "}
                  {filteredPackages.length > 0
                    ? (currentPage - 1) * itemsPerPage + 1
                    : 0}{" "}
                  -{" "}
                  {Math.min(
                    currentPage * itemsPerPage,
                    filteredPackages.length
                  )}{" "}
                  of {filteredPackages.length}
                </span>
              </div>
              <div className="pagination-controls">
                <div className="pagination-buttons">
                  <button
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                    className="pagination-btn"
                  >
                    Previous
                  </button>
                  <span className="page-info">
                    Page {currentPage} of {totalPages || 1}
                  </span>
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage >= totalPages || totalPages === 0}
                    className="pagination-btn"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="super_admin_creator_container">
        <div className="header">
          <p> Packages Creator </p>
          <span>
            <SearchIcon />
            <input
              type="search"
              placeholder="Search Creator by name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </span>
        </div>

        <div className="creator-packages-table">
          {isLoading && <Spinner />}
          {isError && (
            <p style={{ fontFamily: "Montserrat" }}>
              No Creator packages available now
            </p>
          )}
          {!isLoading && !isError && (
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Branch</th>
                  <th>Total Package</th>
                  <th>Package Details</th>
                </tr>
              </thead>
              <tbody>
                {filteredCreator.map((creator, index) => {
                  const isLastElement = filteredCreator.length === index + 1;
                  return (
                    <tr
                      key={creator.creatorId}
                      ref={isLastElement ? lastCreatorElementRef : null}
                    >
                      <td>{creator.creatorId.toUpperCase().slice(0, 8)}</td>
                      <td>{creator.creatorDetails?.first_name || "N/A"}</td>
                      <td>{creator.creatorDetails?.last_name || "N/A"}</td>
                      <td>{creator.creatorDetails?.email || "N/A"}</td>
                      <td>
                        {creator.creatorDetails?.branch_full_address || "N/A"}
                      </td>
                      <td>{creator.totalPackages}</td>
                      <td>
                        <button
                          onClick={() =>
                            handleViewCreatorPackages(creator.creatorId)
                          }
                        >
                          View Package
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        {isFetchingNextPage && <Spinner />}
      </div>
    </>
  );
}

// import React, { useState, useRef, useCallback } from "react";
// import { ReactComponent as SearchIcon } from "../../asset/iconamoon_search-light.svg";
// import useFetchcreatorPackages from "../libs/fetchCreatorPackages";
// import { FaXmark } from "react-icons/fa6";
// import Spinner from "../../utils/spinner";
// import "./Branch_packages.css";

// export default function Superadminallbranchpackages() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [packageOverlay, setPackageOverlay] = useState(false);
//   const [selectedPackages, setSelectedPackages] = useState([]);
//   const [selectedCreatorDetails, setSelectedCreatorDetails] = useState(null);
//   const itemsPerPage = 10;

//   const {
//     data,
//     isLoading,
//     isError,
//     fetchNextPage,
//     isFetchingNextPage,
//     hasNextPage,
//   } = useFetchcreatorPackages();

//   const totalPages = Math.ceil(selectedPackages.length / itemsPerPage);

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage((prevPage) => prevPage + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage((prevPage) => prevPage - 1);
//     }
//   };

//   const creatorArray =
//     data?.pages?.flatMap((page) => page.groupedPackages) || [];

//   const filteredCreator = creatorArray.filter((creator) =>
//     creator?.creatorDetails?.first_name
//       ?.toLowerCase()
//       .includes(searchTerm.toLowerCase())
//   );

//   const observerRef = useRef();
//   const lastCreatorElementRef = useCallback(
//     (node) => {
//       if (isFetchingNextPage) return;
//       if (observerRef.current) observerRef.current.disconnect();

//       observerRef.current = new IntersectionObserver((entries) => {
//         if (entries[0].isIntersecting && hasNextPage) {
//           fetchNextPage();
//         }
//       });

//       if (node) observerRef.current.observe(node);
//     },
//     [isFetchingNextPage, fetchNextPage, hasNextPage]
//   );

//   const handleViewCreatorPackages = (creatorId) => {
//     const selectedCreator = creatorArray.find(
//       (creator) => creator.creatorId === creatorId
//     );
//     setSelectedPackages(selectedCreator?.packages || []);
//     setSelectedCreatorDetails(selectedCreator?.creatorDetails || null);
//     setCurrentPage(1); // Reset page to 1 on each new selection
//     setPackageOverlay(true);
//   };

//   return (
//     <>
//       {packageOverlay && (
//         <div className="creator-package-overlay">
//           <div className="package-info">
//             <span>
//               <h3>
//                 Packages Created by: {selectedCreatorDetails?.first_name}{" "}
//                 {selectedCreatorDetails?.last_name}
//               </h3>
//               <button onClick={() => setPackageOverlay(false)}>
//                 <FaXmark />
//               </button>
//             </span>
//             <table>
//               <thead>
//                 <tr>
//                   <th>Tracking Number</th>
//                   <th>Sender Name</th>
//                   <th>Receiver Name</th>
//                   <th>Item/Weight</th>
//                   <th>Quantity</th>
//                   <th>Date Created</th>
//                   <th>Est. Deliv Date</th>
//                   <th>Shipping Cost</th>
//                   <th>Emergency Deliv</th>
//                   <th>Pick Up</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {selectedPackages.length > 0 ? (
//                   selectedPackages
//                     .slice(
//                       (currentPage - 1) * itemsPerPage,
//                       currentPage * itemsPerPage
//                     )
//                     .map((pkg) => (
//                       <tr key={pkg.tracking_number}>
//                         <td>{pkg.tracking_number}</td>
//                         <td>{pkg.sender?.name}</td>
//                         <td>{pkg.receiver?.name}</td>
//                         <td>
//                           {pkg?.items?.map((item) => (
//                             <div key={item?._id}>
//                               {item?.name} / {item?.weight}kg
//                             </div>
//                           )) || "N/A"}
//                         </td>
//                         <td>
//                           {pkg?.items?.map((item) => (
//                             <div key={item?._id}>{item?.quantity}</div>
//                           )) || 0}
//                         </td>
//                         <td>
//                           {new Date(pkg.dateCreated).toLocaleDateString()}
//                         </td>
//                         <td>
//                           {new Date(
//                             pkg.estimated_delivery_date
//                           ).toLocaleDateString()}
//                         </td>
//                         <td>
//                           {pkg?.shipping_cost?.toLocaleString("en-US", {
//                             style: "currency",
//                             currency: "NGN",
//                           })}
//                         </td>
//                         <td>{pkg.isEmergency ? "Yes" : "No"}</td>
//                         <td>{pkg.isPickupRequired ? "Yes" : "No"}</td>
//                       </tr>
//                     ))
//                 ) : (
//                   <tr>
//                     <td colSpan="11">No packages available</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//             <div className="pagination">
//               <span>{`Showing ${
//                 selectedPackages.length === 0
//                   ? 0
//                   : (currentPage - 1) * itemsPerPage + 1
//               } - ${Math.min(
//                 currentPage * itemsPerPage,
//                 selectedPackages.length
//               )} of ${selectedPackages.length}`}</span>
//               <div className="btn">
//                 <button onClick={handlePrevPage} disabled={currentPage === 1}>
//                   Prev
//                 </button>
//                 <button
//                   onClick={handleNextPage}
//                   disabled={currentPage === totalPages || totalPages === 0}
//                 >
//                   Next
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="super_admin_creator_container">
//         <div className="header">
//           <p> Packages Creator </p>
//           <span>
//             <SearchIcon />
//             <input
//               type="search"
//               placeholder="Search Creator by name"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </span>
//         </div>

//         <div className="creator-packages-table">
//           {isLoading && <Spinner />}
//           {isError && (
//             <p style={{ fontFamily: "Montserrat" }}>
//               No Creator packages available now
//             </p>
//           )}
//           {!isLoading && !isError && (
//             <table>
//               <thead>
//                 <tr>
//                   <th>ID</th>
//                   <th>First Name</th>
//                   <th>Last Name</th>
//                   <th>Email</th>
//                   <th>Branch</th>
//                   <th>Total Package</th>
//                   <th>Package Details</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredCreator.map((creator, index) => {
//                   const isLastElement = filteredCreator.length === index + 1;
//                   return (
//                     <tr
//                       key={creator.creatorId}
//                       ref={isLastElement ? lastCreatorElementRef : null}
//                     >
//                       <td>{creator.creatorId.toUpperCase().slice(0, 8)}</td>
//                       <td>{creator.creatorDetails?.first_name || "N/A"}</td>
//                       <td>{creator.creatorDetails?.last_name || "N/A"}</td>
//                       <td>{creator.creatorDetails?.email || "N/A"}</td>
//                       <td>
//                         {creator.creatorDetails?.branch_full_address || "N/A"}
//                       </td>
//                       <td>{creator.totalPackages}</td>
//                       <td>
//                         <button
//                           onClick={() =>
//                             handleViewCreatorPackages(creator.creatorId)
//                           }
//                         >
//                           View Package
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           )}
//         </div>

//         {isFetchingNextPage && <Spinner />}
//       </div>
//     </>
//   );
// }
